import React, { Component } from 'react';
import jsSHA from "jssha"; // npm install jssha

export class DeleteUserComponent extends Component {
    static displayName = DeleteUserComponent.name;

    constructor(props) {
        super(props);
        const queryString = require('query-string');
        var parsed = queryString.parse(this.props.location.search);

        this.state = {
            userName: '',
            password: '',
            isSubmited: false,
            message: '',
            isPasswordUpdated: false,
            htCustomerToken: props.location.search != "" ? parsed.userguid : "",
            tokenSource: props.location.search != "" ? parsed.source : "",
            errors: {
                userName: '',
                password: ''
            }
        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.clearControl = this.clearControl.bind(this);
        this.calcHash = this.calcHash.bind(this);
    }

    clearControl() {
        this.setState({
            userName: '', password: '', isSubmited: false, message: '', isPasswordUpdated: false,
            errors: {
                userName: '',
                password: ''
            }
        });
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    async componentDidMount() {
        try {
            if (this.state.htCustomerToken !== undefined && this.state.htCustomerToken !== "" && this.state.tokenSource.toLowerCase() === "htcustomer") {
                await this.getExternalHTCustomerRedirectUser();
            }
        } catch (err) {
            console.log("Error in " + this.displayName + ".componentDidMount function", err);
        }
    }

    handleValidation() {
        let errors = this.state.errors;
        let formIsValid = true;
        errors.userName = "";
        errors.password = "";
        this.setState({ message: '' });

        if (this.state.userName == '') {
            formIsValid = false;
            errors.userName = "Please enter username.";
        }

        if (this.state.password == '') {
            formIsValid = false;
            errors.password = "Please enter password.";
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    calcHash(value, securityKey) {
        let shaObj = new jsSHA("SHA-256", "TEXT", { encoding: "UTF8" });
        shaObj.update(value);
        let saltText = shaObj.getHash("HEX");
        let shaObj2 = new jsSHA("SHA-256", "TEXT", { encoding: "UTF8" });
        shaObj2.update(saltText + securityKey);
        return shaObj2.getHash("HEX");
    }

    async handleSubmit(e) {
        e.preventDefault();
        if (this.handleValidation()) {
            this.setState({ isSubmited: true });
            await this.login(false);
        }
    }

    async login(redirectFlag) {
        let passwordHash = "";

        if (this.state.htCustomerToken === "") {
            const tokenRequestParams = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ UserName: this.state.userName })
            }

            const tokenResponse = await fetch('authentication/password-token-request', tokenRequestParams);
            const tokenData = await tokenResponse.json();

            if (tokenData.isSuccess) {
                passwordHash = this.calcHash(this.state.password, tokenData.token);
            } else {
                this.setState({ isSubmited: false, message: tokenData.resultMessage });
                return;
            }
        }

        const requestParams = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                UserName: this.state.userName,
                Password: this.state.htCustomerToken != "" ? this.state.htCustomerToken : passwordHash,
                LoginSource: this.state.tokenSource,
            })
        }
        const response = await fetch('authentication', requestParams);
        const data = await response.json();

        if (data.isSuccess) {
            var userId = parseInt(data.userContext.userId);

            const deleteRequestParams = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    UserId: userId,
                    CreatedBy: userId,
                    MachineIp: "WebApp",
                })
            }

            const deleteResponse = await fetch('user-api/delete-user', deleteRequestParams);
            const deletedata = await deleteResponse.json();
            
            this.setState({ isSubmited: false, message: deletedata.resultMessage })
        }
        else {
            this.setState({ isSubmited: false, message: data.resultMessage })
        }
    }

    render() {
        return (
            <>
                <div className="login-page">
                    <div className="login-box">
                        <div className="card card-login">
                            <div className="card-body">
                                <div className="login-logo mb-0"><img src="../../dist/img/logo_utwiz.png" alt="UTWiz" /></div>
                                <br />
                                {/*<p className="login-box-msg">Sign in to your account!</p>*/}
                                <form method="post" onSubmit={this.handleSubmit} style={this.state.isSubmited ? { pointerEvents: "none", opacity: "0.4" } : {}}>
                                    <div className="form-group mb-3">
                                        <input type="text" className="form-control" name="userName" placeholder="Username" value={this.state.userName} onChange={this.handleInputChange} />

                                        {this.state.errors["userName"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["userName"]}</span>}
                                    </div>
                                    <div className="form-group mb-3">
                                        <input type="password" className="form-control" name="password" placeholder="Password" value={this.state.password} onChange={this.handleInputChange} />
                                        {this.state.errors["password"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["password"]}</span>}
                                        {this.state.message.length > 0 && <span className='error invalid-feedback'>{this.state.message}</span>}
                                    </div>
                                    <div className="row form-group">
                                        {/*<div className="col-5">*/}
                                        {/*    <div className="form-check">*/}
                                        {/*        <input className="form-check-input" type="checkbox" id="remember" />*/}
                                        {/*        <label className="form-check-label" htmlFor="remember">*/}
                                        {/*            Remember Me*/}
                                        {/*        </label>*/}
                                        {/*    </div>*/}
                                        {/*</div>*/}
                                        <div className="col-9 text-right">
                                            <button type="submit" className="btn btn-primary btn-sm" onClick={this.handleSubmit} title="Login" >
                                                {this.state.isSubmited && <span title="Login"><i className="fas fa-spinner fa-spin"></i> Login</span>}
                                                {!this.state.isSubmited && <span title="Login"><i className="fas fa-sign-in-alt"></i> Login</span>}
                                            </button>&nbsp;
                                            <button type="button" className="btn btn-danger btn-sm" onClick={this.clearControl} title="Clear"><i className="fa fa-eraser"></i> Clear</button>
                                        </div>
                                    </div>
                                    {/*<div className="row form-group">*/}
                                    {/*    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">*/}
                                    {/*        <button type="submit" className="btn btn-danger btn-sm" onClick={this.handlePasswordUpdate} title="Login" >*/}
                                    {/*            {this.state.isPasswordUpdated && <span title="Update Password"><i className="fas fa-spinner fa-spin"></i> Update Password</span>}*/}
                                    {/*            {!this.state.isPasswordUpdated && <span title="Update Password"><i className="fas fa-sign-in-alt"></i> Update Password</span>}*/}
                                    {/*        </button>*/}
                                    {/*    </div>*/}
                                    {/*</div>*/}
                                    {/*<div className="row">*/}
                                    {/*    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">*/}
                                    {/*        <div><NavLink tag={Link} to="/forgotpassword" title="I forgot my password" className="text-sm p-0 mb-1">I forgot my password</NavLink></div>*/}
                                    {/*        <div><NavLink tag={Link} to="/plan" title="Register a new membership" className="text-sm p-0 mb-0">Register a new membership</NavLink></div>*/}
                                    {/*    </div>*/}
                                    {/*</div>*/}
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}